<template>
  <section class="ugc-background-color-control">
    <div ref="colorContainer" class="ugc-background-color-control-input-wrapper">
      <input
        v-model="colorValue"
        value="#fff"
        ref="selector_color_input"
        class="jscolor ugc-background-color-control-input"
      />
    </div>
  </section>
</template>

<script>
import BaseUgcTool from "../BaseUgcTool";

export default {
  extends: BaseUgcTool,
  name: "UgcBackgroundColorControl",
  data() {
    return {
      colorValue: "",
      controlName: "background-color"
    };
  },
  computed: {
    fabricCanvas() {
      return this.$store.state.ugc.stateManager.canvas;
    }
  },
  watch: {
    colorValue() {
      this.fabricCanvas.backgroundColor = `#${this.colorValue}`;
      this.fabricCanvas.renderAll();
    }
  },
  methods: {
    setColorPickerOptions() {
      const { clientWidth, clientHeight } = this.$refs.colorContainer;
      this.$refs.selector_color_input.jscolor.width = clientWidth - 56;
      this.$refs.selector_color_input.jscolor.height = clientHeight;
      this.$refs.selector_color_input.jscolor.shadow = false;
      this.$refs.selector_color_input.jscolor.borderWidth = "0";
      this.$refs.selector_color_input.jscolor.borderRadius = "0";
      this.$refs.selector_color_input.jscolor.backgroundColor = "transparent";
      if (this.$store.state.utils.configuration.enableNewUgcModal) {
        this.$refs.selector_color_input.jscolor.insetWidth = 1;
        this.$refs.selector_color_input.jscolor.insetColor = '#ccc';
      } else {
        this.$refs.selector_color_input.jscolor.insetWidth = "0";
      }
      this.$refs.selector_color_input.jscolor.onFineChange = () => {
        this.setColorValue();
      };
    },
    setColorValue() {
      this.colorValue = this.$refs.selector_color_input.jscolor.toString(
        this.$refs.selector_color_input.jscolor.rgb
      );
    },
    onControlDone() {
      this.$store.commit("ugc/tempData/SET_BACKGROUND", `#${this.colorValue}`);
      this.$eventBus.$emit("control-finish", this.controlName);
    }
  },
  mounted() {
    this.$refs.selector_color_input.value = this.fabricCanvas.get("backgroundColor");
    window.jscolor.installByClassName("jscolor");
    this.setColorPickerOptions();
    this.$refs.selector_color_input.jscolor.show();
  },
  beforeDestroy() {
    this.$refs.selector_color_input.jscolor.hide();
  }
};
</script>
